import api from '../utilBackoffice';

const controller = 'Remessa3040';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => {
    return api.Axios.GetParams(url, dto);
  },
  Create: dto => {
    return api.Axios.Post(url, dto);
  },
  Reprocessar: dto => {
    return api.Axios.Post(url + '/Reprocessar', dto);
  },
  Download: dto => {
    return api.Axios.DownloadJsonFile(url + '/Download', dto);
  },
  Delete: dto => {
    return api.Axios.DeleteCommand(url, dto);
  }
});
